import axios from "axios";
import ENV from "../../../environment";

export default {
  state: {
    randProfilOptions: [],
    dachrandOptions: [],
    selection: {},
  },

  mutations: {
    setRandProfilOptions(state, randProfilOptions) {
      state.randProfilOptions = randProfilOptions;
    },

    setDachrandOptions(state, dachrandOptions) {
      state.dachrandOptions = dachrandOptions;
    },

    setSelectedOption(state, option) {
      state.selection = option;
    },
  },

  actions: {
    async fetchDachrandProfilOptions({ commit }) {
      let colors = await axios.get(ENV.baseUrl + ENV.sheetsEndpoint + "?range=dachrandprofil!A1:D20" + "&pluginSetPreview=" + ENV.setPreview);
      if (!colors.data) return;

      let headers = colors.data.shift(); // Get the first row, which contains the header names

      colors = colors.data.map((row, index) => {
        // Map headers to row
        let rowAsObject = {};
        headers.forEach((header, index) => {
          rowAsObject[header] = row[index];
        });

        row = rowAsObject;

        let color = {
          name: row["Optionen"],
          position: index,
          prefix: row["Variantennummer-Prefix"],
        };

        return color;
      });

      commit("setRandProfilOptions", colors);
    },

    async fetchDachrandOptions({ commit }) {
      let options = await axios.get(ENV.baseUrl + ENV.sheetsEndpoint + "?range=Dachrandoptionen!A1:F20" + "&pluginSetPreview=" + ENV.setPreview);
      if (!options.data) return;

      let headers = options.data.shift(); // Get the first row, which contains the header names

      options = options.data.map((row, index) => {
        // Map headers to row
        let rowAsObject = {};
        headers.forEach((header, index) => {
          rowAsObject[header] = row[index];
        });

        row = rowAsObject;

        let option = {
          name: row["Optionen"],
          position: index,
          editable: row["Einstellbar"] == 'JA',
          description: row["Untertitel"],
          fixedAddition: row["Fester Aufschlag (CM)"] || 0,
          image: row["Bild"],
          value: 0
        };

        return option;
      });

      console.log({options});

      commit("setDachrandOptions", options);
    },

    selectOption({ commit }, option) {
      commit("setSelectedOption", option);
    },
  },
};
